import script from "./StarIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./StarIcon.vue?vue&type=script&setup=true&lang=js"

import "./StarIcon.vue?vue&type=style&index=0&id=518f8bf4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-518f8bf4"]])

export default __exports__